@if (applicationService.loadingSubject | async) {
  <div class="loading">
    <mat-spinner class="spinner" color="primary"></mat-spinner>
  </div>
}
